<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-12-03 12:13:44
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-05-06 16:09:53
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierManagement/supplierDetail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 供应商详情页 -->
<template>
  <div class="container">
    <div class="title">
      <span>供应商详情</span>
    </div>
    <base-info
      :companyInfo="companyInfo"
      :companyStandardInfo="companyStandardInfo"
      :companyOtherInfo="companyOtherInfo"
    ></base-info>
    <coopration-info :companyInfo="companyInfo"></coopration-info>
    <certification-info
      :companyInfo="companyInfo"
      :companyOtherInfo="companyOtherInfo"
      :companyDetailInfo="companyDetailInfo"
    ></certification-info>
  </div>
</template>

<script>
import api from '../../api/user';
import baseInfo from './components/baseInfo';
import cooprationInfo from './components/cooprationInfo';
import certificationInfo from './components/certificationInfo';
export default {
  data() {
    return {
      companyInfo: {},
      companyStandardInfo: {},
      companyOtherInfo: {},
      companyDetailInfo: {},
    };
  },

  components: {
    baseInfo,
    cooprationInfo,
    certificationInfo,
  },

  computed: {},

  mounted() {
    let id = this.$route.query.supplierId;
    this.getCompanyInfo({ companyId: id });
    this.getCompanyStandardInfo({ searchtext: id });
    this.getCompanyOtherInfo(id);
    this.queryCompanyDetail({ companyId: id });
  },
  methods: {
    async queryCompanyDetail(params) {
      let res = await api.queryCompanyDetail(params);
      this.companyDetailInfo = res.data;
      console.log(res);
    },
    async getCompanyInfo(params) {
      let res = await api.getCompanyInfo(params);
      this.companyInfo = res.data;
      console.log(res);
    },
    async getCompanyStandardInfo(params) {
      let res = await api.searchSupplierForStore(params);
      if (parseInt(res.code) === 200) {
        this.companyStandardInfo = res.data;
      }
    },
    async getCompanyOtherInfo(params) {
      let res = await api.getSupplierOtherInfo(params);
      if (parseInt(res.code) === 200) {
        this.companyOtherInfo = res.data;
        this.companyOtherInfo.isPdf =
          this.companyOtherInfo.administrative[0].split('.')[1] === 'pdf';
      }
      console.log(this.companyOtherInfo);
      //  if (this.companyOtherInfo.administrative.length !== 0) {
      //   let data = await this.$request.getSupplierLicence({
      //     // 获得市场执照附件
      //     filePath: this.companyOtherInfo.administrative[0]
      //   })
      //   if (data.code == 200) {
      //     if (this.companyOtherInfo.administrative[0].split('.')[1] === 'pdf') {
      //       this.companyOtherInfo.pdfFile = data.data
      //     } else {
      //       this.companyOtherInfo.bigEnclosureImg = data.data;
      //     }
      //     this.companyOtherInfo.enclosureImg = require('@/assets/images/common/license.jpg')
      //   } else if (data.code == 500 || data.message === '内部系统错误') {
      //     this.companyOtherInfo.enclosureImg = require('@/assets/images/common/not-license.jpg')
      //   }
      // } else {
      //   this.companyOtherInfo.enclosureImg = require('@/assets/images/common/not-license.jpg')
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  .title {
    text-align: center;
    line-height: 1;
    margin-bottom: 20px;
    span {
      color: #333;
      font-weight: 500;
      font-size: 20px;
    }
  }
}
</style>
